module.exports = __webpack_public_path__ + "static/media/CAS-Background.be176c40.png";